"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtUnion = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useId = require("../../../helpers/useId");

var SvgBtUnion = function SvgBtUnion(props) {
  var id = (0, _useId.useId)();
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(6,6)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: id,
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.186 1.14a1 1 0 011.628 0l6.056 8.479a1 1 0 01-.813 1.581H11V15H5v-3.8H1.943a1 1 0 01-.814-1.581l6.057-8.48z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.814 1.14L8 1.72l.814-.58zm-1.628 0L8 1.72l-.814-.58zm7.684 8.479l-.813.581.813-.581zM11 11.2v-1a1 1 0 00-1 1h1zm0 3.8v1a1 1 0 001-1h-1zm-6 0H4a1 1 0 001 1v-1zm0-3.8h1a1 1 0 00-1-1v1zM1.13 9.619l.813.581-.814-.581zM9.626.558a2 2 0 00-3.254 0L8 1.72 9.627.558zm6.057 8.48L9.627.558 8 1.72l6.057 8.48 1.627-1.162zM14.057 12.2c1.627 0 2.573-1.839 1.627-3.162L14.057 10.2v2zM11 12.2h3.057v-2H11v2zm-1-1V15h2v-3.8h-2zm1 2.8H5v2h6v-2zm-5 1v-3.8H4V15h2zm-4.057-2.8H5v-2H1.943v2zM.316 9.038C-.63 10.36.316 12.2 1.943 12.2v-2L.316 9.038zM6.373.558L.316 9.038 1.943 10.2 8 1.72 6.373.558z",
    fill: "currentColor",
    mask: "url(#".concat(id, ")")
  })));
};

exports.SvgBtUnion = SvgBtUnion;